import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import './Header.css';

export default function Header({ language, setLanguage, t }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-link" onClick={() => window.scrollTo(0, 0)}>
          <img
            src="/images/logo/dplogo.webp"
            alt="DP Architecture"
            className="logo"
            width="132"
            height="64"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="desktop-nav">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            {t.nav.home}
            <span className="nav-underline" />
          </Link>
          <Link to="/agency" className={`nav-link ${isActive('/agency') ? 'active' : ''}`}>
            {t.nav.agency}
            <span className="nav-underline" />
          </Link>
          <Link to="/projects" className={`nav-link ${isActive('/projects') || isActive('/project/') ? 'active' : ''}`}>
            {t.nav.projects}
            <span className="nav-underline" />
          </Link>
          <Link to="/missions" className={`nav-link ${isActive('/missions') ? 'active' : ''}`}>
            {t.nav.missions}
            <span className="nav-underline" />
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
            {t.nav.contact}
            <span className="nav-underline" />
          </Link>
          <Link to="/news" className={`nav-link ${isActive('/news') ? 'active' : ''}`}>
            {t.nav.news}
            <span className="nav-underline" />
          </Link>
          <Link to="/faq" className={`nav-link ${isActive('/faq') ? 'active' : ''}`}>
            FAQ
            <span className="nav-underline" />
          </Link>

          <button onClick={() => setLanguage(language === 'fr' ? 'en' : 'fr')} className="language-toggle">
            {language === 'fr' ? 'EN' : 'FR'}
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <Menu size={24} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            <Link to="/" className={`mobile-nav-link ${isActive('/') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.home}
            </Link>
            <Link to="/agency" className={`mobile-nav-link ${isActive('/agency') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.agency}
            </Link>
            <Link to="/projects" className={`mobile-nav-link ${isActive('/projects') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.projects}
            </Link>
            <Link to="/missions" className={`mobile-nav-link ${isActive('/missions') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.missions}
            </Link>
            <Link to="/contact" className={`mobile-nav-link ${isActive('/contact') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.contact}
            </Link>
            <Link to="/news" className={`mobile-nav-link ${isActive('/news') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              {t.nav.news}
            </Link>
            <Link to="/faq" className={`mobile-nav-link ${isActive('/faq') ? 'active' : ''}`} onClick={() => setMobileMenuOpen(false)}>
              FAQ
            </Link>
            <button onClick={() => setLanguage(language === 'fr' ? 'en' : 'fr')} className="mobile-language-toggle">
              {language === 'fr' ? 'EN' : 'FR'}
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}